export default {
  namespaced: true,

  state: {
    pastIssues: [],
    recentIssues: {},
    issues: [],
    stories: [],
    story: {},
    latestIssues: []
  },
  getters: {
    getPastIssues: state => {
      return state.pastIssues
    },
    getRecentIssues: state => {
      return state.recentIssues
    },
    getStoriesForIssue: state => {
      return state.stories
    },
    getStory: state => {
      return state.story
    },
    getAllIssues: state => {
      return state.issues
    },
    getLatestIssues: state => {
      return state.issues.slice(0, 6)
    }
  },
  mutations: {
    SET_PAST_ISSUES (state, issues) {
      state.pastIssues = issues || []
    },
    SET_RECENT_ISSUES (state, issues) {
      state.recentIssues = issues || []
    },
    SET_ALL_ISSUES (state, issues) {
      state.issues = issues
    },
    SET_LATEST_ISSUES (state, latestIssues) {
      state.latestIssues = latestIssues
    },
    SET_ISSUE_STORIES (state, stories) {
      state.stories = stories
    },
    SET_STORY (state, story) {
      state.story = story
    },
    SET_ERROR (state, error) {
      state.error = error
    }
  },
  actions: {
    async getIssues ({ commit }) {
      const issues = await this.$api.getAllIssues()
      issues.data.sort(function (a, b) {
        return new Date(b.publishDate) - new Date(a.publishDate)
      })
      commit('SET_ALL_ISSUES', issues.data)
      return issues.data
    },

    async getStories ({ commit }, issueName) {
      const stories = await this.$api.getIssueStories(issueName)
      commit('SET_ISSUE_STORIES', stories.data)
      return stories.data
    },

    async getSingleStory ({ commit }, issueName, storyId) {
      const story = await this.$api.getAStory(issueName, storyId)
      commit('SET_STORY', story.data)
      return story.data
    },

    async issueVote ({ commit }, issueObj) {
      await this.$api.voteOnIssue(issueObj.issueId, issueObj.voteDelta)
      return commit
    }
  }
}
